import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './container/index';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'popper.js/dist/popper.min.js';
import './assets/css/main.css';
import 'react-responsive-pagination/themes/classic.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { AppProvider } from './core/Contexts/AppContext';
import { LanguageProvider } from './core/Contexts/LanguageContext';

import reportWebVitals from './reportWebVitals';

// Get the root element
const rootElement = document.getElementById('root');

// Create a root
const root = ReactDOM.createRoot(rootElement);

// Render the App
root.render(
    <AppProvider>
      {/* <div className='test'>ვებგვერდი მუშაობს სატესტო რეჟიმში</div> */}
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </AppProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
